var _rect, _rect2, _path, _path2, _line, _line2, _rect3, _rect4, _line3, _line4, _rect5, _rect6, _line5, _line6, _rect7, _rect8, _line7, _line8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcon = function SvgIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 108,
    viewBox: "0 0 140 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 108,
    rx: 1.57895,
    fill: "#FDFDFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 54,
    height: 38,
    rx: 3,
    fill: "#F1F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 31.3L28.7692 34L38 25",
    stroke: "#343A40",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 32V38.2222C37 38.6937 36.8127 39.1459 36.4793 39.4793C36.1459 39.8127 35.6937 40 35.2222 40H22.7778C22.3063 40 21.8541 39.8127 21.5207 39.4793C21.1873 39.1459 21 38.6937 21 38.2222V25.7778C21 25.3063 21.1873 24.8541 21.5207 24.5207C21.8541 24.1873 22.3063 24 22.7778 24H32.5556",
    stroke: "#5750FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 28,
    x2: 58.0005,
    y2: 28,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 36,
    x2: 54,
    y2: 36,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 57,
    width: 55,
    height: 38,
    rx: 3,
    fill: "#F1F3F5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 68,
    width: 16,
    height: 16,
    rx: 2,
    stroke: "#343A40",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 72,
    x2: 58.0005,
    y2: 72,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 80,
    x2: 54,
    y2: 80,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 57,
    width: 55,
    height: 38,
    rx: 3,
    fill: "#F1F3F5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 68,
    width: 16,
    height: 16,
    rx: 2,
    stroke: "#343A40",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 72,
    x2: 118,
    y2: 72,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 80,
    x2: 114,
    y2: 80,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 13,
    width: 55,
    height: 38,
    rx: 3,
    fill: "#F1F3F5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 24,
    width: 16,
    height: 16,
    rx: 2,
    stroke: "#343A40",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 28,
    x2: 118,
    y2: 28,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 36,
    x2: 114,
    y2: 36,
    stroke: "#ADB5BD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";